import { CachedGETRequest } from '../../classes/cached-request';

export interface RefreshRequestQueueState {
    refreshRequests: { [url: string]: CachedGETRequest };
}

export const initialRefreshRequestQueueState: RefreshRequestQueueState = {
    refreshRequests: {},
};
